import { api } from '@/lib/api';

export const downloadContactFile = async (path, filename, params) => {
  try {
    const response = await api.get(path, { params, responseType: 'blob' });
    const url = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url; link.download = filename; document.body.appendChild(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (error) {
    if (error.response?.data instanceof Blob) {
      try { const body = JSON.parse(await error.response.data.text()); if (typeof body.detail === 'string') error.message = body.detail; } catch {}
    }
    throw error;
  }
};